class Previewer {

    constructor(element) {

        this.element = $(element);

        this.events();
    }

    events() {

        let self = this;

        this.element.on('click', function () {

            if (typeof $(this).data('type') == 'undefined') {

                console.log('no data-type provided.');
                return;
            }

            self.createTab();
        });

        $(document).on('click', '.previewer-tab .device', function () {

            $('.previewer-tab .device').removeClass('selected');
            $(this).addClass('selected');

            let size = self.getDeviceWidth();

            size += Math.round((size / 100) * 10);

            $('.previewer-tab .case').css('width', size + "px");
            $('.previewer-tab .case iframe').css('width', "100%");

            self.setCookie('previewer', $(this).data('type'));
        });

        $(document).on('click', '.previewer-tab .btn-preview-close', function () {

            $('.content .previewer-tab').addClass('closed');

            setTimeout(function () {
                $('.previewer-tab').remove();
                $('body').css('overflow', 'auto');
                self.closeFullscreen();
            }, 750);
        });
    }

    getDeviceWidth(device = false) {

        let selected = device,
            size;

        if (selected === false) {
            selected = $('.previewer-tab .device.selected').data('type');
        }

        if (selected == 'desktop') {
            size = 1200;
        }
        if (selected == 'laptop') {
            size = 992;
        }
        if (selected == 'tablet') {
            size = 768;
        }
        if (selected == 'mobile') {
            size = 576;
        }
        if (selected == 'mobile-small') {
            size = 450;
        }

        return size;
    }

    createTab() {

        if ($('.content .previewer-tab').length > 0) {
            return;
        }

        let selected = this.getCookie('previewer'),
            size,
            anchor = '',
            anchorElement = '';

        if (selected == '') {
            selected = 'desktop';
        }

        size = this.getDeviceWidth(selected);
        size += Math.round((size / 100) * 10);

        if (typeof this.element.data('anchor') != 'undefined') {
            anchor = '#' + this.element.data('anchor');
            anchorElement = this.element.data('anchor');
        }


        this.tab = $(`
            <div class="previewer-tab closed">
                <div class="header">

                    <div class="container">
                        <div class="row d-flex align-items-center">

                            <div class="col">

                                <div class="row">

                                    <div class="device`+ (selected == 'desktop' ? ' selected' : '') + `" data-type="desktop">
                                        <div>
                                            <i class="fas fa-desktop"></i>
                                        </div>
                                        <div>Desktop</div>
                                        <div>≥ 1200px</div>
                                    </div>

                                    <div class="device`+ (selected == 'laptop' ? ' selected' : '') + `" data-type="laptop">
                                        <div>
                                            <i class="fas fa-laptop"></i>
                                        </div>
                                        <div>Laptop</div>
                                        <div>≥ 992px</div>
                                    </div>

                                    <div class="device`+ (selected == 'tablet' ? ' selected' : '') + `" data-type="tablet">
                                        <div>
                                            <i class="fas fa-tablet-alt"></i>
                                        </div>
                                        <div>Tablet</div>
                                        <div>≥ 768px</div>
                                    </div>

                                    <div class="device`+ (selected == 'mobile' ? ' selected' : '') + `" data-type="mobile">
                                        <div>
                                            <i class="fas fa-mobile-alt"></i>
                                        </div>
                                        <div>Phone</div>
                                        <div>≥ 576px</div>
                                    </div>

                                    <div class="device`+ (selected == 'mobile-small' ? ' selected' : '') + `" data-type="mobile-small">
                                        <div>
                                            <i class="fas fa-mobile-alt"></i>
                                        </div>
                                        <div>Small Phone</div>
                                        <div>< 576px</div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-auto text-right">
                                <button type="button" class="btn-preview-close">Close</button>
                            </div>

                        </div>
                    </div>

                </div>
                <div class="content">

                    <div class="container-fluid h-100 d-flex justify-content-center align-items-center">

                        <div class="case" style="width:`+ size + `px">
                            <iframe id="previewer-tab-iframe" style="width:100%" src="`+ this.element.data('domain') + `/` + this.element.data('slug') + `?previewer_token=` + this.element.data('token') + `"></iframe>
                            <div class="loading">
                                <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>

                    </div>
                    
                </div>
            </div> 
        `);

        $('.content').append(this.tab);

        this.openFullscreen();

        setTimeout(function () {
            $('body').css('overflow', 'hidden');
            $('.content .previewer-tab').removeClass('closed');
        }, 100);

        document.getElementById('previewer-tab-iframe').onload = function () {

            setLoading('.case', 'remove');

            $('#previewer-tab-iframe')[0].contentWindow.document.body.style.zoom = 0.8;

            if (anchor != '') {

                let iframe = document.getElementById('previewer-tab-iframe'),
                    anchorOffsetTop = iframe.contentWindow.document.getElementById(anchorElement).offsetTop,
                    headerOffsetTop = iframe.contentWindow.document.getElementsByTagName("header")[0].offsetHeight;

                iframe.contentWindow.scrollTo(
                    0,
                    anchorOffsetTop - headerOffsetTop);

            }
        };
    }

    setCookie(cname, cvalue, exdays = 100) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    openFullscreen() {
        let elm = document.documentElement;
        if (elm.requestFullscreen) {
            elm.requestFullscreen();
        } else if (elm.webkitRequestFullscreen) { /* Safari */
            elm.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE11 */
            elm.msRequestFullscreen();
        }
    }

    closeFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Safari */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen();
        }
    }
}